import { TFileTypes } from '@interfaces/import/import';

import { EFileExtensions, EMIMETypes } from '@enums/common';
import { EDropzoneFileErrorCodes } from '@enums/dropzone';

export const acceptedFileTypesJson: TFileTypes = {
	[EMIMETypes.json]: [EFileExtensions.json],
};

export const acceptedFileTypesXML: TFileTypes = {
	[EMIMETypes.xml]: [EFileExtensions.xml],
};

const MAX_MEGA_BYTES = 10;

export const MAX_BYTES = MAX_MEGA_BYTES * 1e+6;

export const fileErrorsJson = {
	[EDropzoneFileErrorCodes.fileInvalidType]: 'Extension is not supported. Supports: JSON',
	[EDropzoneFileErrorCodes.fileTooLarge]: `The file size must be less than ${MAX_MEGA_BYTES}MB`,
};

export const fileErrorsXML = {
	[EDropzoneFileErrorCodes.fileInvalidType]: 'Extension is not supported. Supports: XML',
	[EDropzoneFileErrorCodes.fileTooLarge]: `The file size must be less than ${MAX_MEGA_BYTES}MB`,
};

export const supportsTextJson = 'Supports: JSON';
export const supportsTextXML = 'Supports: XML';
